import service from "service"

const base_url = `${process.env.REACT_APP_BASE_URL_API}/booking`
class Api {
  store(data) {
    return service.post(base_url, data)
  }
}

export default new Api()